<template>
    <div class="mb10 order__radio-group-block">
        <div v-for="(deliv, index) in local_todoors">
            <input v-model="local_dtype" class="order__radio"
                   :id="deliv.data.deliv_type_id" name="DelivForm[dtype]"
                   :value="deliv.data.deliv_type_id" type="radio"
                   @change="changeDelivery"
            />
            <label class="order__radio-label-block" :for="deliv.data.deliv_type_id">
                <span class="order__radio-fake mb5">
                    <span class="order__radio-name">{{ deliv.cost }} Р</span>

                    <span v-show="isCheaper(index)" class="order__radio-note order__radio-note--green ml5">Самая дешевая</span>
                </span>
                <span>
                    <span v-show="deliv.calc.srok != ''" class="order__radio-term mb5">{{ getSrok(deliv.calc.srok) }}</span>
                    <span v-show="isFaster(index)" class="order__radio-note order__radio-note--red ml5">Самая быстрая</span>
                </span>
                 <span v-html="deliv.data.name" class="order__radio-term mb5"></span>
                <span class="deliv-logo">
                    <span v-html="deliv.data.help"></span>
                    <span><img class="order__radio-img" :src="getIcon(deliv.data)" alt=""/></span>
                </span>
            </label>
        </div>
    </div>
</template>

<script>
    import {helpers} from './../helpers.js';
    export default {
        name: "courier-select",
        props: {
            todoors: {
                type: Array,
                default: []
            },
            dtype: {
                type: String
            },
            baseurl: {
                type: String
            }
        },
        mixins: [helpers],
        data() {
            return {
                local_todoors: this.todoors,
                local_dtype: this.dtype,
                localBaseUrl: this.baseurl
            }
        },
        methods: {
            isCheaper(index) {
                let index_min = null;
                let cost_min = null;

                for(var i=0; i<this.local_todoors.length; i++) {
                    let cost = parseFloat(this.local_todoors[i].cost);
                    if(cost < cost_min || cost_min === null) {
                        cost_min = cost;
                        index_min = i;
                    }
                }

                let min_count = 0;
                for(var i=0; i<this.local_todoors.length; i++) {
                    let cost = parseFloat(this.local_todoors[i].cost);
                    if(cost === cost_min) {
                        min_count++;
                    }
                }

                if(min_count > 1) {
                    return false;
                } else {
                    return (index === index_min);
                }
            },
            isFaster(index) {
                let index_min = null;
                let srok_min = null;
                for(var i=0; i<this.local_todoors.length; i++) {
                    let srok = parseInt(this.local_todoors[i].calc.srok);
                    if(srok < srok_min) {
                        srok_min = srok;
                        index_min = i;
                    }
                }

                let srok_min_count = 0;
                for(var i=0; i<this.local_todoors.length; i++) {
                    let srok = parseInt(this.local_todoors[i].calc.srok);
                    if(srok===srok_min) {
                        srok_min_count++;
                    }
                }

                if(srok_min_count > 1) {
                    return false;
                } else {
                    return (index === index_min);
                }
            },
            changeDelivery() {
                this.$store.dispatch('setDelivTypeId', this.local_dtype)
                /*console.log('dtype changed');

                let params = new URLSearchParams();
                params.append('param', 'dtype');
                params.append('value', this.local_dtype);
                axios.put('/rest/order', params);

                Event.fire('DTypeChanged', this.local_dtype)*/
            },
            getIcon (deliv_type) {
                if(typeof deliv_type.logo !== 'undefined') {
                    return deliv_type.logo
                }
                let ret = this.localBaseUrl + '/img/deliv/hc.png';
                switch (deliv_type.deliv_type_id) {
                    case 3: //ems
                        ret = this.localBaseUrl + '/img/deliv/ems.png';
                        break;
                    case 33: //почта россии
                        ret = this.localBaseUrl + '/img/deliv/russian_post.png';
                        break;
                    case 57: //sdek
                        ret = this.localBaseUrl + '/img/deliv/sdek.png';
                        break;
                }
                return ret;
            },
            getSrok(val) {
                if(val === parseInt(val, 10)) {
                    return val + ' ' + this.getNoun(val, 'день', 'дня', 'дней')
                } else {
                    return val
                }
            }
        }
    }
</script>

<style scoped>
    .deliv-logo {
        display: flex;
    }
    .deliv-logo span {
        color: #000000;
    }
</style>
